import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import ShopSetup from '../components/shop/ShopSetup';
import ShopQRCodeSection from '../components/shop/ShopQRCodeSection';
import BottomNav from '../components/BottomNav';
import Header from '../components/Header';
import BackButton from '../components/BackButton';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopRegistryPage() {
  const navigate = useNavigate();
  const { isAuthenticated, loading: authLoading } = useAuth();
  const [shop, setShop] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!isAuthenticated) {
      navigate('/');
      return;
    }
    const load = async () => {
      try {
        const res = await axios.get(`${API}/shops/my`, { withCredentials: true });
        setShop(res.data);
      } catch (e) {
        if (e.response?.status === 404) navigate('/negoziante');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [authLoading, isAuthenticated, navigate]);

  const handleSaved = (updatedShop) => {
    setShop(updatedShop);
    toast.success('Dati negozio aggiornati');
  };

  if (authLoading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 pb-24" data-testid="shop-registry-page">
      <Header />
      {/* Same layout / spacing as InventarioPage to keep the Back button anchored
          in a consistent position across all shop-management screens. */}
      <main className="max-w-6xl mx-auto px-4 py-4">
        <BackButton fallback="/dashboard" className="mb-3" />
        <h1 className="font-outfit font-bold text-2xl sm:text-3xl text-slate-800 mb-4">Dati negozio</h1>
        <ShopSetup shop={shop} onShopCreated={handleSaved} isEdit mode="anagrafica" />
        {/* v1.8.8 — QR Code section for the storefront's public URL.
            Rendered only when the shop has been saved (has an id), so the
            QR always points to a resolvable /negozio/{id} page. */}
        {shop?.id && <ShopQRCodeSection shop={shop} />}
      </main>
      <BottomNav />
    </div>
  );
}
